import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';

interface DraftCheckInConfirmationDialogProps {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  onConfirm: () => void;
  onEditDraft: () => void;
}

export const DraftCheckInConfirmationDialog = ({
  isOpen,
  onOpenChange,
  onConfirm,
  onEditDraft,
}: DraftCheckInConfirmationDialogProps) => (
  <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>You have a draft check-in</AlertDialogTitle>
        <AlertDialogDescription>
          Would you like to edit the existing draft or create a new one?
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel>Cancel</AlertDialogCancel>
        <Button variant="outline" onClick={onEditDraft}>
          Edit Draft
        </Button>
        <AlertDialogAction onClick={onConfirm}>Create New</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
